<template>

  <div class="wrap">
    <Nav :activeId="activeId" />

    <div class="page-banner" style="display: ;">
      <!-- <div class="top-breadcrumb">
        <img src="../../img/news/nav-top.png" class="news" />
      </div> -->
      <div class="nav-bar">
        <!-- <div class="nav-bar_label">Explore Bänninger</div> -->
        <div class="nav-bar_label">Conex Bänninger Discovery</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>探索班尼戈</span>新闻动态
        </div>
      </div>

      <!-- swiper start -->
      <div class="index-section-swiper">
        <div class="index-swiper-container" ref="interSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
              
              <div class="img">
                <img :src="item.img" class="" alt="" />
                <div class="mask">
                  <img src="../../img/news/mask-bg.png" />
                  <div class="layer">
                    <div class="title">{{ item.title }}</div>
                    <a :href="item.url" class="btn">Read More ></a>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>

          <div class="swiper-button-prev">
            <img src="../../img/index/icon-left-big.png" />
          </div>
          <div class="swiper-button-next">
            <img src="../../img/index/icon-right-big.png" />
          </div>
        </div>
      </div>
      <!-- swiper end -->
    </div>

    <div class="section-one self-bg">
      <div class="sub-title">
        <img src="../../img/news/sub-title2.png" />
      </div>
      <div class="news-list">
        <div class="item" v-for="(item, index) in newsList" :key="index">
          <div class="news-img"><a :href="item.url"><img :src="item.img" /></a></div>
          <div class="news-info">
            <div class="__title">{{ item.short }}</div>
            <div class="basic">
              <div class="desc">
                <a :href="item.url">{{ item.title }}</a>
              </div>
              <div class="date">DATE：{{ item.date }}</div>
            </div>
          </div>
        </div>
        <!-- <a href="/news-detail/2"><img src="../../img/news/item/1.jpg" /></a>
        <a href="/news-detail/3"><img src="../../img/news/item/2.jpg" /></a>
        <a href="/news-detail/4"><img src="../../img/news/item/3.jpg" /></a>
        <a href="/news-detail/5"><img src="../../img/news/item/4.jpg" /></a> -->
      </div>
    </div>

    <Footer />

  </div>

</template>

<script>
import { getNewsList } from "@/api/index";
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 0,
      activeIndex: 0,
      index: 0,
      swiperList: [
        // {
        //   id: 1,
        //   img: require('@/img/news/detail/banner/1.jpg'),
        //   title: '水启·聚势·谋远 | 2023班尼戈全国经销商大会经典回顾',
        //   url: '/news-detail/1'
        // },
        // {
        //   id: 2,
        //   img: require('@/img/news/detail/banner/2.jpg'),
        //   title: '黔城共鉴,筑新征程 | 西南区域首家班尼戈贵阳活水体验中心盛大开业',
        //   url: '/news-detail/2'
        // },
        // {
        //   id: 3,
        //   img: require('@/img/news/detail/banner/3.jpg'),
        //   title: '群贤毕至,共襄盛举 | 2023中外豪宅设计T20峰会 引领高净值人士居住新理念',
        //   url: '/news-detail/3'
        // },
        // {
        //   id: 4,
        //   img: require('@/img/news/detail/banner/4.jpg'),
        //   title: '现场直击 | 班尼戈水暖系统 重磅亮相2023北京ISH展',
        //   url: '/news-detail/4'
        // },
        // {
        //   id: 5,
        //   img: require('@/img/news/detail/banner/5.jpg'),
        //   title: '水由新生·境启未来 | 德国班尼戈 X 设计大咖齐聚蓉城 开启六维水管理健康之旅',
        //   url: '/news-detail/5'
        // }
      ],
      newsList: [
        // {
        //   id: 2,
        //   img: require('@/img/news/item/1.jpg'),
        //   title: '黔城共鉴,筑新征程',
        //   desc: '西南区域首家班尼戈贵阳活水体验中心盛大开业',
        //   date: '2023-06-01',
        //   url: '/news-detail/2'
        // },
        // {
        //   id: 2,
        //   img: require('@/img/news/item/2.jpg'),
        //   title: '群贤毕至，共襄盛举',
        //   desc: '2023中外豪宅设计丁20峰会 引领高净值人士居住新理念',
        //   date: '2023-06-01',
        //   url: '/news-detail/3'
        // },
        // {
        //   id: 2,
        //   img: require('@/img/news/item/3.jpg'),
        //   title: '现场直击',
        //   desc: '班尼戈水暖系统 重磅亮相2023北京ISH展',
        //   date: '2023-05-12',
        //   url: '/news-detail/4'
        // },
        // {
        //   id: 2,
        //   img: require('@/img/news/item/4.jpg'),
        //   title: '水由新生 • 境启末来',
        //   desc: '德国班尼戈×设计大咖齐聚蓉城 开启六维水管理健康之旅',
        //   date: '2023-04-01',
        //   url: '/news-detail/5'
        // }
      ]
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    console.log('mounted');
    // 加载Swiper数据
    this.loadData();
    // Swiper 初始化
    new Swiper(".index-swiper-container", {
      observer: true,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      loop: true,
      // 显示分页
      pagination: {
        el: ".swiper-pagination",
        clickable: true, //允许分页点击跳转
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        hideOnClick: true
      },
      on: {
        slideChange: function() {
          console.log(this.realIndex, 'realIndex', this)
        }
      }
    })
  },
  methods: {
    loadData() {
      console.log(111)
      getNewsList().then((res) => {
        console.log(res);
        this.swiperList = res.data.data.swiper;
        this.newsList   = res.data.data.list;

        // this.initSwiper()
      });
    },
    initSwiper() {
      new Swiper(".index-swiper-container", {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,
        loop: true,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          hideOnClick: true
        },
        on: {
          slideChange: function() {
            console.log(this.realIndex, 'realIndex', this)
          }
        }
      })
    },
    changeSwipe(type) {
      if(type == 'up') {
        this.index -= 1;
      } else if (type == 'down') {
        this.index += 1;
      }
      this.$refs.swiper.swipeTo(this.activeIndex+1);
    },
    onChange (index) {
      console.log(index)
      this.activeIndex = index
    },
    goPrev() {
      this.$refs.swiper.prev();
    },
    goNext() {
      this.$refs.swiper.next();
    }
  }
};
</script>

<style scoped lang="less">
.page-banner {
  position: relative;
}
.self-bg {
  min-height: 500px;
  // padding: 30px 0;
  background-color: #EFEFEF;
  overflow: auto;
  padding: 100px 0 200px;
}
.sub-title {
  width: 1100px;
  margin: 0 auto 50px;
  img {
    width: 100%;
    height: auto;
  }
}
.news-list {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  img {
    width: 1100px;
    height: 266px;
    margin-bottom: 30px;
  }
  .item {
    width: 1100px;
    height: 266px;
    margin-bottom: 30px;
    position: relative;
    background-color: #1A1A1A;
    // display: flex;
    // justify-content: flex-end;
    .news-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 586px;
      height: 100%;
      img {
        width: 100%;
        // object-fit: cover;
        // width: 100%;
        // height: 100%;
        // position: absolute;
        // top: 0;
        // left: 0;
        // z-index: -9;
      }
    }
    .news-info {
      position: absolute;
      top: 0;
      right: 34px;
      width: 448px;
      height: 100%;
      padding: 30px 0 20px;
      box-sizing: border-box;
      // border: 1px solid yellow;
      // background-color: yellow;
      // color: red;
      color: #FFF;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .__title {
        width: 100%;
        font-size: 24px;
        padding-bottom: 20px;
        border-bottom: 1px solid #8B8C8C;
        // border-bottom: 1px solid blue;
      }
      .basic {
        height: 140px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .desc {
          padding-right: 80px;
          font-size: 20px;
          a {
            color: #FFF;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .date {
          font-size: 16px;
        }
      }
      // background-color: red;
    }
  }
}
.swiper-container {
  --swiper-theme-color: #FFF;/* 设置Swiper风格 */
  --swiper-navigation-color: #FFF;/* 单独设置按钮颜色 */
  --swiper-navigation-size: 64px;/* 设置按钮大小 */
  // --swiper-navigation-size: 0 !important;
  // --swiper-pagination-color: #fff;
}
/* 去除默认前进后退按钮 */
.swiper-button-prev, .swiper-button-next {
  background: transparent;
  width: 48px;
  height: 48px;
}
.swiper-button-next:after, .swiper-button-prev:after {
  display: none;
}
// 首页顶部
.index-section-swiper {
  width: 100%;
  // overflow: auto;  
  .index-swiper-container {
    position: relative;
  }
  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      height: 100%;
      user-select: none;
      text-align: center;
      transition: 300ms;
      box-sizing: border-box;
      .img {
        width: 100%;
        height: 100%;
        text-align: center;
        margin: auto;
        img {
          margin: auto;
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
        .mask {
          width: 100%;
          position: absolute;
          bottom: 0;
          .layer {
            width: 1100px;
            position: absolute;
            margin: 0 auto;
            top: 50%;
            left: 0;
            right: 0;
            // bottom: 50px;
            color: #FFF;
            text-align: left;
            .title {
              font-size: 28px;
              font-weight: bold;
              margin-bottom: 10px;
              letter-spacing: 3px;
            }
            .btn {
              // margin-top: 30px;
              width: 129px;
              height: 29px;
              line-height: 29px;
              text-align: center;
              // background-color: #013D7F;
              // background-color: #013D7F;
              border-radius: 50px;
              border: 1px solid #FFF;
              color: #FFF;
              font-size: 18px;
              display: inline-block;
            }
            // .btn {
            //   width: 146px;
            //   height: 31px;
            // }
          }
        }
      }
    }
  }
  .swiper-button-prev { left: 5%; }
  .swiper-button-next { right: 5% }
}
</style>
<style lang="less">
/* 小圆点的样式，需要单独写一个不带scoped属性的style标签 */
.swiper-pagination-fraction, .swiper-pagination-custom, 
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 50px;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 10px;
}
.swiper-pagination-bullet {
  // margin-left: 20px;
  width: 12px;
  height: 12px;
  border: 1px solid #FFF;
  background-color: transparent;
  opacity: 1;
  &.swiper-pagination-bullet-active {
      // width: 10px;
      // height: 10px;
      border-radius: 50%;
      background-color: #fff;
  }
}
</style>